var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8V6H15V8H10ZM10 4V2H18V4H10ZM5 18C3.61667 18 2.4375 17.5125 1.4625 16.5375C0.4875 15.5625 0 14.3833 0 13C0 12.2 0.175 11.4542 0.525 10.7625C0.875 10.0708 1.36667 9.48333 2 9V3C2 2.16667 2.29167 1.45833 2.875 0.875C3.45833 0.291667 4.16667 0 5 0C5.83333 0 6.54167 0.291667 7.125 0.875C7.70833 1.45833 8 2.16667 8 3V9C8.63333 9.48333 9.125 10.0708 9.475 10.7625C9.825 11.4542 10 12.2 10 13C10 14.3833 9.5125 15.5625 8.5375 16.5375C7.5625 17.5125 6.38333 18 5 18ZM2 13H8C8 12.5167 7.89583 12.0667 7.6875 11.65C7.47917 11.2333 7.18333 10.8833 6.8 10.6L6 10V3C6 2.71667 5.90417 2.47917 5.7125 2.2875C5.52083 2.09583 5.28333 2 5 2C4.71667 2 4.47917 2.09583 4.2875 2.2875C4.09583 2.47917 4 2.71667 4 3V10L3.2 10.6C2.81667 10.8833 2.52083 11.2333 2.3125 11.65C2.10417 12.0667 2 12.5167 2 13Z",
    fill: "#171C1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.a35b2cc68d53cb669a24d631c924298f.svg";
export { ForwardRef as ReactComponent };